import { TextContentElement } from '@deltek/specification-client/core/Models/textContentElement'
import { create } from 'zustand'
import {
    BPStagedConfig,
    initialBPStagedConfig,
} from '../types/bpManagement.types'

export interface BPVersionPreviewSnapshot {
    contentItemId: string
    originalElements: Partial<TextContentElement>[]
}

interface BestPracticeManagementState {
    /** Content item ID to filter audit history by. null = show full iteration history. */
    auditContentItemFilter: string | null
    setAuditContentItemFilter: (id: string | null) => void
    /** Snapshot of original elements before a version preview was applied. null = no active preview. */
    previewSnapshot: BPVersionPreviewSnapshot | null
    setPreviewSnapshot: (snap: BPVersionPreviewSnapshot | null) => void
    /** ID of the tip card currently being previewed in the workspace. */
    activeTipId: string | null
    /** Best practice ID from the selected tip card — passed as `id` to addUpdateBestPractice to target a specific BP. */
    selectedBestPracticeId: string | null
    /** Content item ID of the selected tip card — used to validate double-click targets. */
    selectedTipContentItemId: string | null | undefined
    /** Staged config snapshot at the moment the tip card was selected — used to detect unchanged updates. */
    originalTipStagedConfig: BPStagedConfig | null
    setOriginalTipStagedConfig: (config: BPStagedConfig | null) => void
    /** Set active tip state together, or clear all with nulls. */
    setActiveTip: (
        tipId: string | null,
        bestPracticeId: string | null,
        contentItemId?: string | null
    ) => void
    stagedConfig: BPStagedConfig
    setStagedConfig: (config: BPStagedConfig) => void
}

export const useBestPracticeManagementStore = create<
    BestPracticeManagementState
>()((set) => ({
    auditContentItemFilter: null,
    setAuditContentItemFilter: (id) => set({ auditContentItemFilter: id }),
    previewSnapshot: null,
    setPreviewSnapshot: (snap) => set({ previewSnapshot: snap }),
    activeTipId: null,
    selectedBestPracticeId: null,
    selectedTipContentItemId: null,
    originalTipStagedConfig: null,
    setOriginalTipStagedConfig: (config) =>
        set({ originalTipStagedConfig: config }),
    setActiveTip: (tipId, bestPracticeId, contentItemId = null) =>
        set({
            activeTipId: tipId,
            selectedBestPracticeId: bestPracticeId,
            selectedTipContentItemId: contentItemId,
        }),
    stagedConfig: initialBPStagedConfig,
    setStagedConfig: (config) => set({ stagedConfig: config }),
}))
